var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "KmTooltip",
    { attrs: { bottom: "" } },
    [
      _c("KmIcon", {
        staticClass: "status-icon-component",
        attrs: {
          slot: "activator",
          name: _vm.icon,
          color: _vm.color,
          title: _vm.title
        },
        slot: "activator"
      }),
      _vm._v("\n  " + _vm._s(_vm.title) + "\n")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }